import { Globe, Moon, Sun } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { LANGUAGES } from "@/i18n/translations";
import { useLang } from "@/context/LangContext";
import { useTheme } from "@/context/ThemeContext";

export const LanguageSwitcher = () => {
  const { lang, setLang, t } = useLang();
  return (
    <Select value={lang} onValueChange={setLang}>
      <SelectTrigger
        data-testid="language-switcher-dropdown"
        aria-label={t("language")}
        className="h-10 w-auto gap-2 rounded-full border-border bg-card px-3 text-sm font-semibold"
      >
        <Globe className="h-4 w-4 text-primary" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent align="end">
        {LANGUAGES.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`language-option-${l.code}`}>
            {l.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export const ThemeToggle = () => {
  const { theme, toggle } = useTheme();
  const dark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="theme-toggle-button"
      aria-label="Toggle theme"
      className="relative flex h-10 w-10 items-center justify-center overflow-hidden rounded-full border border-border bg-card transition-colors hover:bg-muted"
    >
      <Sun className={`absolute h-4 w-4 text-amber-500 transition-transform duration-500 ${dark ? "translate-y-8 rotate-90" : "translate-y-0"}`} />
      <Moon className={`absolute h-4 w-4 text-primary transition-transform duration-500 ${dark ? "translate-y-0" : "-translate-y-8 -rotate-90"}`} />
    </button>
  );
};
